import { render, staticRenderFns } from "./SpecsValuesSort.vue?vue&type=template&id=4118d044&scoped=true"
import script from "./SpecsValuesSort.vue?vue&type=script&lang=js"
export * from "./SpecsValuesSort.vue?vue&type=script&lang=js"
import style0 from "./SpecsValuesSort.vue?vue&type=style&index=0&id=4118d044&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4118d044",
  null
  
)

export default component.exports